import { createApiRef } from "@backstage/core-plugin-api";
import { GitHubClient } from "@internal/backstage-plugin-github-common";

/**
 * ApiRef for the GitHub plugin client.
 *
 * @public
 */
export const githubApiRef = createApiRef<GitHubClient>({
    id: "plugin.github.service",
});
